export default {
  credentials: 'https://23e6da048d984c42a23d6b17ef8181e1@o124964.ingest.sentry.io/1469155'
}
